import gql from 'graphql-tag'
import { EntityFields } from '..'
import { PersonFragment } from '../persons/person'
import { EmployeeFragment } from '../hr'
import { PipelineFragment } from '../crm/pipeline'
import { ProcessStatusFragment } from '../settings/processStatus'
import { ClosingReasonFragment } from '../settings/closingReason'

export const BaseLeadFragment = gql`
  ${PersonFragment}
  fragment LeadBase on crm_lead {
    ${EntityFields}
    executive {
      ...Employee
      person{
        ...Person
      }
    }
  }
`

export const LeadFragment = gql`
  ${BaseLeadFragment}
  ${PersonFragment}
  ${EmployeeFragment}
  ${PipelineFragment}
  ${ProcessStatusFragment}
  ${ClosingReasonFragment}
  fragment Lead on crm_lead {
    ...LeadBase
    client {
      ...Person
    }
    forwarder {
      ...Employee
    }
    pipeline {
      ...Pipeline
    }
    status {
      ...ProcessStatus
    }
    closingReason: closing_reason {
      ...ClosingReason
    }
  }
`
